<div class="planDoc-list" *ngIf="showPlanDocList">
  <!-- Kiểm tra nếu có dữ liệu trong orderList -->
  <div *ngIf="orderList && orderList.length > 0; else noData">
    <div 
      *ngFor="let planDoc of orderList" 
      class="planDoc-item"
      (click)="
        selectDocument(planDoc);
        docModal.open(selectedDocModal1, { size: 'lg', centered: true, backdrop: 'static' })
      ">
      
      <h5 class="text-start">{{ planDoc.createdAt.toDate() | date: 'dd/MM/yyyy' }}</h5>
      <p>{{ planDoc.providerEmail }}</p>

      <p 
        *ngIf="planDoc.followUpDate"
        [ngClass]="{ 'bg-warning text-dark px-2 py-1 rounded': isFollowUpTomorrow(planDoc.followUpDate) }"
      >
        <b>Hẹn khám lại:</b>
        {{ planDoc.followUpDate | date: 'dd/MM/yyyy' }}
      </p>
    </div>
  </div>

  <!-- Nội dung hiển thị nếu không có dữ liệu -->
  <ng-template #noData>
    <div class="no-data-message">
      <p>Chưa có hồ sơ được lưu trữ</p>
    </div>
  </ng-template>
</div>

<ng-template #selectedDocModal1 let-modal>
  <div class="modal-header dark-modal">
    <h4 class="modal-title">
      {{ selectedDocument.createdAt.toDate() | date: 'dd/MM/yyyy HH:mm' }}
    </h4>
    <button 
      *ngIf="selectedDocument"
      class="btn btn-outline-secondary"
      (click)="downloadPDF()"
    >
      PDF
    </button>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body dark-modal">
    <div>
      <h6><b>Thuốc:</b></h6>
      <ol *ngIf="selectedDocument?.medications?.length">
        <li *ngFor="let medication of selectedDocument.medications">
          <p>
            {{ medication.brandName }} - Số lượng: {{ medication.quantity }} -
            {{ medication.use }}
          </p>
        </li>
      </ol>
      <h6><b>Hướng dẫn:</b></h6>
      <ul *ngIf="selectedDocument.guide?.length > 0">
        <li *ngFor="let guide of selectedDocument.guide">
          {{ guide }}
        </li>
      </ul>
      <h6><b>File:</b></h6>
      <div *ngIf="!loadingFileList">
        <ul *ngIf="selectedDocument.files?.length > 0">
          <li *ngFor="let file of selectedDocument.files">
            <span (click)="viewUploadedFile(file)" class="file-link">
              {{ file.name }}
            </span>
          </li>
        </ul>
      </div>
      <div *ngIf="loadingFileList" class="center2">
        <div class="loader"></div>
      </div>
      <div *ngIf="currentViewedFile">
        <div class="center2" *ngIf="loadingFileSelectedOther">
          <div class="loader"></div>
        </div>
        <ngx-doc-viewer
          *ngIf="currentViewedFile.type !== 'image'"
          [url]="currentViewedFile.url"
          viewer="url"
          (loaded)="contentLoaded()"
          [googleCheckContentLoaded]="true"
          [googleCheckInterval]="3000"
          [googleMaxChecks]="10"
          class="doc-viewer"
        ></ngx-doc-viewer>
        <img
          *ngIf="currentViewedFile.type === 'image'"
          [src]="currentViewedFile.url"
          [alt]="currentViewedFile.name"
          class="image-viewer"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer dark-modal">
    <button 
      *ngIf="!selectedDocument.status?.includes('7')"
      class="btn btn-outline-warning"
      (click)="complain(true)"
    >
      Khiếu nại
    </button>
    <button 
      *ngIf="selectedDocument.status?.includes('7')"
      class="btn btn-outline-success"
      (click)="complain(false)"
    >
      Hủy khiếu nại
    </button>
    <button 
      *ngIf="selectedDocument.medications?.length > 0 && !selectedDocument.status?.includes('6')"
      class="btn btn-outline-info"
      (click)="updatePlan()"
    >
      Đặt mua thuốc theo đơn
    </button>
    <div *ngIf="selectedDocument.status?.includes('6')" class="text-success">
      Đã đặt mua thuốc!
    </div>
    <!-- Nút bổ sung thông tin mới -->
    <button 
      class="btn btn-outline-primary"
      (click)="openAdditionalInfoModal()"
    >
      <i class="fas fa-plus-circle me-1"></i>
      Bổ sung thông tin
    </button>
  </div>

</ng-template>

<!-- Modal bổ sung thông tin -->
<ng-template #additionalInfoModal let-modal>
  <div class="modal-header dark-modal">
    <h4 class="modal-title">Bổ sung thông tin cá nhân</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body dark-modal" style="max-height: 70vh; overflow-y: auto;">
    <form #additionalInfoForm="ngForm">
      <!-- Thông tin cá nhân bổ sung -->
      <div class="section-group mb-4">
        <h6 class="section-title"><b>Thông tin cá nhân</b></h6>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Nghề nghiệp</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.occupation" name="occupation" placeholder="Ví dụ: Kỹ sư, Giáo viên...">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Số CMND/CCCD</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.idNumber" name="idNumber" placeholder="Nhập số CMND/CCCD">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Người liên hệ khẩn cấp</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.emergencyContact" name="emergencyContact" placeholder="Họ tên người thân">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">SĐT khẩn cấp</label>
            <input type="tel" class="form-control" [(ngModel)]="additionalInfo.emergencyPhone" name="emergencyPhone" placeholder="Số điện thoại người thân">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Số thẻ BHYT</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.insuranceNumber" name="insuranceNumber" placeholder="Mã số thẻ bảo hiểm y tế">
          </div>
        </div>
      </div>

      <!-- Tiền sử bệnh và sức khỏe -->
      <div class="section-group mb-4">
        <h6 class="section-title"><b>Tiền sử bệnh và sức khỏe</b></h6>
        <div class="mb-3">
          <label class="form-label">Tiền sử bệnh gia đình</label>
          <textarea class="form-control" rows="3" [(ngModel)]="additionalInfo.familyHistory" name="familyHistory" placeholder="Các bệnh di truyền, bệnh mãn tính trong gia đình..."></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Dị ứng (thuốc, thức ăn, môi trường...)</label>
          <textarea class="form-control" rows="2" [(ngModel)]="additionalInfo.allergies" name="allergies" placeholder="Mô tả các loại dị ứng đã biết..."></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Thuốc đang sử dụng thường xuyên</label>
          <textarea class="form-control" rows="2" [(ngModel)]="additionalInfo.currentMedications" name="currentMedications" placeholder="Tên thuốc, liều lượng, tần suất sử dụng..."></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Tiền sử phẫu thuật</label>
          <textarea class="form-control" rows="2" [(ngModel)]="additionalInfo.surgicalHistory" name="surgicalHistory" placeholder="Các ca phẫu thuật đã thực hiện, thời gian..."></textarea>
        </div>
        
        <!-- Các bệnh mãn tính -->
        <div class="row">
          <div class="col-md-4 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="additionalInfo.hasDiabetes" name="hasDiabetes" id="hasDiabetes">
              <label class="form-check-label" for="hasDiabetes">Tiểu đường</label>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="additionalInfo.hasHeartDisease" name="hasHeartDisease" id="hasHeartDisease">
              <label class="form-check-label" for="hasHeartDisease">Bệnh tim mạch</label>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="additionalInfo.hasLungDisease" name="hasLungDisease" id="hasLungDisease">
              <label class="form-check-label" for="hasLungDisease">Bệnh phổi</label>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="additionalInfo.hasPastInjuries" name="hasPastInjuries" id="hasPastInjuries">
              <label class="form-check-label" for="hasPastInjuries">Chấn thương cũ</label>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="additionalInfo.isPregnantOrNursing" name="isPregnantOrNursing" id="isPregnantOrNursing">
              <label class="form-check-label" for="isPregnantOrNursing">Đang mang thai/cho con bú</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Triệu chứng hiện tại -->
      <div class="section-group mb-4">
        <h6 class="section-title"><b>Triệu chứng và tình trạng hiện tại</b></h6>
        <div class="mb-3">
          <label class="form-label">Lý do khám chính</label>
          <textarea class="form-control" rows="2" [(ngModel)]="additionalInfo.chiefComplaint" name="chiefComplaint" placeholder="Mô tả triệu chứng chính khiến bạn đến khám..."></textarea>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Thời gian xuất hiện triệu chứng</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.symptomDuration" name="symptomDuration" placeholder="Ví dụ: 3 ngày, 1 tuần...">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Mức độ nghiêm trọng (theo cảm nhận)</label>
            <select class="form-control" [(ngModel)]="additionalInfo.symptomSeverity" name="symptomSeverity">
              <option value="">Chọn mức độ</option>
              <option value="Nhẹ">Nhẹ - Không ảnh hưởng sinh hoạt</option>
              <option value="Trung bình">Trung bình - Ảnh hưởng một phần</option>
              <option value="Nặng">Nặng - Ảnh hưởng nghiêm trọng</option>
            </select>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Các triệu chứng kèm theo</label>
          <textarea class="form-control" rows="2" [(ngModel)]="additionalInfo.associatedSymptoms" name="associatedSymptoms" placeholder="Các triệu chứng khác xuất hiện cùng lúc..."></textarea>
        </div>
      </div>

      <!-- Thông tin sức khỏe cơ bản -->
      <div class="section-group mb-4">
        <h6 class="section-title"><b>Thông tin sức khỏe cơ bản (tự đo tại nhà)</b></h6>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Cân nặng (kg)</label>
            <input type="number" class="form-control" [(ngModel)]="additionalInfo.vitalSigns.weight" name="weight" (input)="calculateBMI()" placeholder="Ví dụ: 65">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Chiều cao (cm)</label>
            <input type="number" class="form-control" [(ngModel)]="additionalInfo.vitalSigns.height" name="height" (input)="calculateBMI()" placeholder="Ví dụ: 170">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">BMI (tự động tính)</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.vitalSigns.bmi" name="bmi" readonly placeholder="Sẽ tự động tính">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Huyết áp (nếu có máy đo)</label>
            <input type="text" class="form-control" [(ngModel)]="additionalInfo.vitalSigns.bloodPressure" name="bloodPressure" placeholder="Ví dụ: 120/80">
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer dark-modal">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
      Hủy
    </button>
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="saveAdditionalInfo(modal)"
      [disabled]="savingAdditionalInfo"
    >
      <span *ngIf="savingAdditionalInfo" class="spinner-border spinner-border-sm me-2"></span>
      {{ savingAdditionalInfo ? 'Đang lưu...' : 'Lưu thông tin' }}
    </button>
  </div>
</ng-template>

<app-pdf #pdfComp [selectedDocument]="selectedDocument"></app-pdf>
